import { render, staticRenderFns } from "./Sponsorships.vue?vue&type=template&id=a7beda58&scoped=true&"
import script from "./Sponsorships.vue?vue&type=script&lang=js&"
export * from "./Sponsorships.vue?vue&type=script&lang=js&"
import style0 from "./Sponsorships.vue?vue&type=style&index=0&id=a7beda58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7beda58",
  null
  
)

export default component.exports